<div *ngIf="currentDocument$ | async as currentDocumentSnapshot" style="overflow: visible">
  <div *ngIf="currentDocumentSnapshot" style="margin: 7px 15px;">
    <lex-flat-button label="Apply previous coding changes" icon="fa-duotone fa-copy icon" id="same-as-last-button"
      *ngIf="lastChangeSet$ | async as lastChangeSet" (click)="sameAsLastIt()"
      style="margin-top: 6px; margin-bottom:6px;" [matTooltip]="toolTipMessage$ | async"></lex-flat-button>
  </div>
  <mat-accordion multi displayMode="flat">
    <lex-built-in-coding-section></lex-built-in-coding-section>
    <lex-custom-coding-section *ngFor="let parent of customCodingFieldsManager.getParents()" [customField]="parent">
    </lex-custom-coding-section>
    <button *inRole="[roles.ManageCustomDocFieldsFeatureSet]" mat-flat-button class="add-coding-field-button" 
    style="display: block; margin: 16px auto; font-weight: 400;" (click)="addNewField()">Add new field</button>
  </mat-accordion>
</div>

